<template>
  <div class="ankang-trace">
    <div class="trace-banner-wrap">
      <img class="trace-banner" src="/static/images/ankang/banner.png" alt="秦岭高山凰散养原生土鸡" />
    </div>

    <div class="trace-card">
      <div class="trace-title-wrap">
        <span class="trace-title-bar"></span>
        <span class="trace-title">详细溯源信息</span>
      </div>

      <div class="trace-list">
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/pinpai.png" alt="品牌名称" />
          <div class="trace-item-text"><span class="trace-label">品牌名称：</span><span class="trace-value">{{ displayTraceInfo.brandName }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/guige.png" alt="规格名称" />
          <div class="trace-item-text"><span class="trace-label">规格名称：</span><span class="trace-value">{{ displayTraceInfo.productName }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/tianshu.png" alt="饲养天数" />
          <div class="trace-item-text"><span class="trace-label">饲养天数：</span><span class="trace-value">{{ displayTraceInfo.feedDays }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/bianhao.png" alt="编号" />
          <div class="trace-item-text"><span class="trace-label">#NO.编号：</span><span class="trace-value">{{ displayTraceInfo.traceNo }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/yangzhic.png" alt="养殖场名称" />
          <div class="trace-item-text"><span class="trace-label">养殖场名称：</span><span class="trace-value">{{ displayTraceInfo.farmName }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/tuzai.png" alt="屠宰日期" />
          <div class="trace-item-text"><span class="trace-label">屠宰日期：</span><span class="trace-value">{{ displayTraceInfo.slaughterTime }}</span></div>
        </div>
        <div class="trace-item">
          <img class="trace-item-icon" src="/static/images/ankang/time.png" alt="出库日期" />
          <div class="trace-item-text"><span class="trace-label">出库日期：</span><span class="trace-value">{{ displayTraceInfo.outboundTime }}</span></div>
        </div>
        <div class="trace-item trace-item-last">
          <img class="trace-item-icon" src="/static/images/ankang/chuku.png" alt="出库仓库" />
          <div class="trace-item-text"><span class="trace-label">出库仓库：</span><span class="trace-value">{{ displayTraceInfo.warehouseName }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoByCode } from '../../api/api'

export default {
  name: 'AnKangTrace',
  data() {
    return {
      code: '',
      traceInfo: null
    }
  },
  created() {
    this.initPage()
  },
  computed: {
    displayTraceInfo() {
      const info = this.traceInfo || {}
      return {
        brandName: info.brandName || '',
        productName: info.productName || '',
        feedDays: info.f10 || '',
        traceNo: info.f11 || '',
        farmName: info.f12 || '',
        slaughterTime: info.f13 || '',
        outboundTime: info.f14 || '',
        warehouseName: info.f15 || ''
      }
    }
  },
  methods: {
    async initPage() {
      const params = this.$route.query || {}
      const routeCode = params.code || params.c || ''
      this.code = routeCode.substring(0, 16)
      if (!this.code) {
        return
      }
      await this.loadCodeInfo()
    },
    async loadCodeInfo() {
      try {
        const res = await getInfoByCode(this.code)
        if (res.data && res.data.code === '200' && res.data.data) {
          this.traceInfo = res.data.data
        }
      } catch (e) {
      }
    }
  }
}
</script>

<style scoped>
.ankang-trace {
  width: 100vw;
  min-height: 100vh;
  background: #eeeeee;
  padding-bottom: 4.5vh;
  box-sizing: border-box;
}

.trace-banner-wrap {
  width: 100%;
}

.trace-banner {
  width: 100%;
  display: block;
}

.trace-card {
  width: 96vw;
  margin: -25.5vw auto 0;
  padding: 4.8vh 6vw 4.6vh;
  background: #ffffff;
  border-radius: 34px;
  position: relative;
  z-index: 1;
}

.trace-title-wrap {
  display: flex;
  align-items: center;
}

.trace-title-bar {
  width: 1.2vw;
  min-width: 5px;
  height: 3.6vh;
  min-height: 28px;
  background: rgb(179, 155, 119);
  border-radius: 2px;
}

.trace-title {
  margin-left: 3.6vw;
  font-size: 4.9vw;
  line-height: 1.1;
  font-weight: 700;
  color: rgb(179, 155, 119);
}

.trace-list {
  margin-top: 4vh;
}

.trace-item {
  display: flex;
  align-items: flex-start;
  padding: 2.45vh 0;
  border-bottom: 1px solid #e7e7e7;
}

.trace-item-last {
  border-bottom: 0;
}

.trace-item-icon {
  width: 4.2vw;
  max-width: 17px;
  margin-top: 0.2vh;
  flex-shrink: 0;
}

.trace-item-text {
  flex: 1;
  margin-left: 3vw;
  font-size: 0;
  line-height: 1.38;
  color: #1f1f1f;
}

.trace-label,
.trace-value {
  font-size: 3.8vw;
  line-height: 1.38;
  color: #1f1f1f;
  vertical-align: top;
}

.trace-label {
  margin-right: 1vw;
}

@media screen and (max-width: 350px) {
  .trace-card {
    padding-left: 6vw;
    padding-right: 6vw;
    border-radius: 28px;
  }

  .trace-title {
    font-size: 4.8vw;
  }

  .trace-label,
  .trace-value {
    font-size: 3.7vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnKang/Trace.vue